<template>
  <div>
    <component
        :is="currentMethodComponent"
        :method="method"
        :instructions-data="instructionsData"
        :can-cancel="canCancel"
        @completed="handleCompleted"
        @cancel="handleCancel"
        @title-change="titleChange"
    />
  </div>
</template>

<script>
import {twoFactorAuthStore} from "@/store/pinia/twoFactorAuthStore";
import TotpMethodInstructions from '@/components/_security/methods/TotpMethodInstructions.vue';
import EmailMethodInstructions from '@/components/_security/methods/EmailMethodInstructions.vue';
import BackupCodesMethodInstructions from '@/components/_security/methods/BackupCodesMethodInstructions.vue';

export default {
  name: 'TwoFactorMethodRegistrationInstructions',
  components: {
    TotpMethodInstructions,
    EmailMethodInstructions,
    BackupCodesMethodInstructions,
  },
  props: {
    instructionsData: {
      type: Object,
      required: false,
      default: null
    },
    method: {
      type: Object,
      required: true,
    },
    canCancel: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const twoFactorAuth = twoFactorAuthStore();
    return {twoFactorAuth};
  },
  computed: {
    currentMethodComponent() {
      const methodComponentMap = {
        'totp': 'TotpMethodInstructions',
        'email': 'EmailMethodInstructions',
        'backup_codes': 'BackupCodesMethodInstructions',

      };

      return methodComponentMap[this.method?.slug] || null;
    }
  },
  methods: {

    titleChange(newTitle) {
    this.$emit('title-change',newTitle)

    },

    handleCompleted(payload) {
      this.$emit('completed', payload);
    },

    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
